export default function move(array, from, to) {
  const newArray = [ ...array ];

  newArray.splice(to, 0, newArray.splice(from, 1)[0]);
  return newArray;
};
